import store from "@/store";

const isAdminGuard = async(to, from, next) => {
    const { typeUser } = store.state.auth.user;
    if (typeUser === 3) return next();
    else return next({ name: "menugeneral" });
}

export default isAdminGuard;